'use strict';

module.exports = {
  CHANGE_EVENT: 'changed',
  FETCH_CHANGE_EVENT: 'fetch-changed'
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/marty-lib/modules/store/storeEvents.js
 ** module id = 240
 ** module chunks = 0
 **/